import { useLayoutEffect, useEffect } from 'react';

// https://medium.com/@alexandereardon/uselayouteffect-and-ssr-192986cdcf7a

/** @deprecated Don't use this hook. Create one in your code. */
export const useIsomorphicLayoutEffect =
  typeof window !== 'undefined' ? useLayoutEffect : useEffect;
